// Central brand config — override per environment, no rebuild-time scatter.
export const APP_NAME = process.env.REACT_APP_APP_NAME || 'Showly';
export const TAGLINE = process.env.REACT_APP_TAGLINE || 'On-demand home showings by licensed agents';
